import "./About.css";

function About() {
  return <section className="about-section">About</section>;
}

export default About;
